import "./_locations-styles.scss";

 import './locations';
